import { Stack } from '@koob/margaret';
import { KoobEnableableSection } from '@koob/ui';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import TextFieldButton from './TextFieldButton';

const PromotionPaxRestrictionField = ({ name }) => {
  const { t } = useTranslation('promotionForm');
  const [{ value }, , { setValue }] = useField({ name });

  const getPaxRestrictionDescription = (values) => {
    const { minPax, maxPax, enabled } = values ?? {};

    if (!enabled || (!minPax && !maxPax)) {
      return t('paxRestriction.noRestriction');
    }

    if (minPax && maxPax && minPax === maxPax) {
      return t('paxRestriction.exact', { pax: minPax });
    }

    if (minPax && maxPax) {
      return t('paxRestriction.range', { min: minPax, max: maxPax });
    }

    if (minPax) {
      return t('paxRestriction.minOnly', { min: minPax });
    }

    return t('paxRestriction.maxOnly', { max: maxPax });
  };

  return (
    <KoobEnableableSection
      title={t('paxRestriction.title')}
      description={getPaxRestrictionDescription(value)}
      onCheckedChange={(enabled) => {
        setValue((values) => ({ ...values, enabled }));
      }}
      checked={value?.enabled}
    >
      <Stack alignY="center" alignX="space-between" size="full">
        <TextFieldButton
          name={`${name}.minPax`}
          label={t('paxRestriction.minPax')}
          type="number"
          step="1"
          min="1"
        />
        <TextFieldButton
          name={`${name}.maxPax`}
          label={t('paxRestriction.maxPax')}
          type="number"
          step="1"
          min="1"
        />
      </Stack>
    </KoobEnableableSection>
  );
};

export default PromotionPaxRestrictionField;
